FileSaver// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { Component, OnInit, OnDestroy, AfterViewInit, Input, TemplateRef, ViewChild, Output, EventEmitter, HostBinding } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { MatPaginator, MatSort, MatTableDataSource, MatSnackBar, MatDialog } from '@angular/material';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { AccountService } from "../../services/account.service";
import { Poze } from 'src/app/models/poze.model';
import * as FileSaver from 'file-saver'; 

@Component({
  selector: 'poze',
  templateUrl: './poze.component.html',
  styleUrls: ['./poze.component.scss'],
  animations: [fadeInOut]
})
export class PozeComponent {
  private isSaving: boolean;
  private isNew: boolean;
  pozeForm: FormGroup;
  poze: Poze;
  definirePoze: boolean = false;

  displayedColumns = ['actions','productGroup', 'vehicleReference', 'photoReference', 'photo'];
  loadingIndicator: boolean = true;
  productGroup: string = '';
  vehicleReference: string = '';
  photoReference: string = '';
  data: Poze[];
  dataSource: MatTableDataSource<Poze>;
  isDataLoaded: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  afuConfig = {
    uploadAPI: {
      url: "https://example-file-upload-api"
    }
  };

  constructor(
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
  )
  {
    this.dataSource = new MatTableDataSource<Poze>();
    this.buildForm();
  }

  afiseazaDate() {
    this.loadingIndicator = true;

    let productGroup = this.productGroup == null || this.productGroup == "" ? "undefined" : this.productGroup;
    let vehicleReference = this.vehicleReference == null || this.vehicleReference == "" ? "undefined" : this.vehicleReference;
    let photoReference = this.photoReference == null || this.photoReference == "" ? "undefined" : this.photoReference;

    this.accountService
      .getPozeLists(productGroup, vehicleReference, photoReference)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.data = liniiReconverted;
        
        this.dataSource.data = this.data;

        this.isDataLoaded = true;

        setTimeout(() => { this.loadingIndicator = false; }, 1500);

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
        error => {
        });

  }

  ngOnInit() {
    this.poze = new Poze();
    this.afiseazaDate();
  }

  modificare(poze: Poze) {
    this.definirePoze = true;
    this.poze = poze;
  }

  verificareStergere(poze: Poze) {
    this.alertService.showDialog('Delete', 'Do you confirm the deletion?', DialogType.confirm, () => this.stergePoze(poze));
  }

  stergePoze(poze: Poze) {
    poze.status = "D";
    this.accountService.savePoze(poze).subscribe(
      role => {
        this.saveSuccessHelper(this.poze, `Photo deleted!`);
        this.afiseazaDate();
      },
      error => this.saveFailedHelper(error));
  }

  adaugare() {
    this.definirePoze = true;
    this.poze = new Poze();
  }

  private saveSuccessHelper(Poze?: Poze, mesaj?: string) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();

    this.alertService.showMessage("Success", `Photo information saved successfully!`, MessageSeverity.success);

    this.definirePoze = false;
    this.afiseazaDate();
  }

  private saveFailedHelper(error: any) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();
    this.alertService.showStickyMessage("Save Error", "Errors in saving process: ", MessageSeverity.error, error);
    this.alertService.showStickyMessage(error, null, MessageSeverity.error);
  }

  private buildForm() {
    this.pozeForm = this.formBuilder.group({
      tbProductGroup: ['', Validators.required],
      tbVehicleReference: ['', Validators.required],
      tbPhotoReference: ['', Validators.required],
    });
  }

  get tbProductGroup() {
    return this.pozeForm.get('tbProductGroup');
  }

  get tbVehicleReference() {
    return this.pozeForm.get('tbVehicleReference');
  }

  get tbPhotoReference() {
    return this.pozeForm.get('tbPhotoReference');
  }

  private cancel() {
    this.definirePoze = false;
  }

  handleFileInputCI(files: FileList) {
    this.poze.photo = files.item(0);
  }

  incarcaPoza() {
    if (this.poze.photo == null) {
      this.alertService.stopLoadingMessage();
      this.alertService.showStickyMessage("Error on uploading photo", "Photo not selected!", MessageSeverity.error);
      return;
    }

    const formData = new FormData();
    formData.append('file', this.poze.photo, this.poze.photo.name);

    this.accountService.uploadPhoto(this.poze.productGroup, this.poze.vehicleReference, this.poze.photoReference, formData).subscribe((result) => {
      this.alertService.stopLoadingMessage();
      this.alertService.showMessage("Photo Upload", "Photo successfully uploaded!", MessageSeverity.success);
      this.afiseazaDate();
    },
      error => {
        this.alertService.stopLoadingMessage();
        this.alertService.showStickyMessage("Error on upload", "Errors: ", MessageSeverity.error, error);
        this.alertService.showStickyMessage(error, null, MessageSeverity.error);
      });
  }

  reset() {
    this.productGroup = '';
    this.vehicleReference = '';
  }

  GetPhotoUrl(poza: Poze): string {
    return '/' + poza.vehicleReference + "_" + poza.photoReference + "_" + poza.id + ".jpg";
  }

}
